import { Box, Button, Chip, Tab, Tabs, Typography } from '@mui/material';

import { Check, Warning } from '@mui/icons-material';
import { apiPost, AppModels, AppState, DriveXLSXMimeType, expectedTabAcierColumnNames, expectedTabListeLogColumnNames, expectedTabPourteIntColumnNames, jsonPost, ProjectDataAttrs, projectDataSelector, projectDataSlice, ProjectDataState, saveModel, TabAcierColumns, TabListLogColumns, TabPorteIntData } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { appStore } from '../../store';
import { GoogleFileFolderSelector, GoogleFinderMode } from '../googledrive/GoggleFileSystem';

export const ProjectData = (props: { projectId: ModelId; }) => {

    const [updloadFile, setUploadFile] = React.useState<File | undefined>();

    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));
    const [selectGoogleFile, setSelectGoogleFile] = React.useState(false);
    const rafraichirGoogleDriveData = async () => {
        if (projectData && projectData.driveFileId) {
            await saveModel(AppModels.projectDatas, { id: projectData.id, state: ProjectDataState.WAITING });
        }
    };

    React.useEffect(() => {
        if (updloadFile) {
            uploadProjectDataFile();
        }
    }, [updloadFile]);

    const uploadProjectDataFile = async () => {
        if (updloadFile) {
            const data = new FormData();

            data.append('files', updloadFile);
            const xhr = new XMLHttpRequest();
            const response: any | ProjectDataAttrs = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        console.log("upload progress:", event.loaded / event.total);
                    }
                });
                xhr.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {

                    }
                });
                xhr.addEventListener("loadend", () => {
                    resolve(xhr.readyState === 4 && xhr.status === 200 ? JSON.parse(xhr.response) : 'Erreur');
                    setUploadFile(undefined);
                });
                xhr.open("POST", '/project/' + props.projectId + '/uploadprojectdata', true);
                xhr.send(data);
            });
            if ('id' in response) {
                appStore.dispatch(projectDataSlice.actions.upsertOne(response as ProjectDataAttrs));
            } else if ('error' in response) {
                alert(response.error);
            } else {
                alert('Impossible de télécharger');
            }
            console.log('response', response);
        }
    };

    return <>
        <Button onClick={() => { setSelectGoogleFile(true); }}>Sélectionner le document Excel dans Google Drive</Button>
        {projectData && projectData.driveFileId && <Button onClick={() => { rafraichirGoogleDriveData; }}>Rafraichir les données</Button>}
        <Button variant='contained' onClick={async () => {
            jsonPost('/project/dotest', { projectId: 1, driveFileId: '18O2shkzn7S4AY7fNsv_Ef1rswU4lTypa' });
        }}>TEST</Button>
        <input
            accept={DriveXLSXMimeType}
            style={{ display: 'none' }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={(event) => setUploadFile(event.target.files?.[0])}
        />
        <label htmlFor="raised-button-file">
            <Button variant="contained" component="span">
                Téléverser
            </Button>
        </label>
        {selectGoogleFile && <GoogleFileFolderSelector onFileSelected={async file => {
            console.log('file', file);
            if (file) {
                const response = await apiPost('projectSetDataFromGoogleDriveFile', { projectId: props.projectId, driveFileId: file.id });
                appStore.dispatch(projectDataSlice.actions.upsertOne(response));
                console.log('response', response);
            }
            setSelectGoogleFile(false);

        }} mode={GoogleFinderMode.SELECT_XLSX} />}
        <ProjectDataInspector projectId={props.projectId} />
    </>;
};


const ProjectDataInspector = (props: { projectId: ModelId; }) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));
    if (!projectData) {
        return <Typography>Aucune donnée de projet disponible.</Typography>;
    }

    return (<>
        <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example">
            <Tab icon={projectData?.tabAcier ? (projectData?.tabAcier.values.length ? <Check color='success' /> : <Warning color='warning' />) : undefined} iconPosition="start" label="Quincaillerie acier" />
            <Tab icon={projectData?.tabListeLog ? (projectData?.tabListeLog.values.length ? <Check color='success' /> : <Warning color='warning' />) : undefined} iconPosition="start" label="Liste des logements" />
            <Tab icon={projectData?.tabPorteInt ? (projectData?.tabPorteInt.values.length ? <Check color='success' /> : <Warning color='warning' />) : undefined} iconPosition="start" label="Portes intérieures" />
        </Tabs>
        {value === 0 && <ProjectDataTabAcierInspector projectId={props.projectId} />}
        {value === 1 && <ProjectDataTabListLogInspector projectId={props.projectId} />}
        {value === 2 && <ProjectDataTabPorteIntInspector projectId={props.projectId} />}

    </>
    );
};

const ProjectDataTabAcierInspector = (props: { projectId: ModelId; }) => {
    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));
    if (!projectData) {
        return <Typography>Aucune donnée de projet disponible.</Typography>;
    }
    // row states
    return <Box>
        {!!projectData?.tabAcier ? <Typography>
            {(Object.keys(projectData.tabAcier.columns) as (keyof TabAcierColumns<any>)[]).map((p: keyof TabAcierColumns<any>) => {
                return <Chip component='span' key={p} color={projectData?.tabAcier?.columns[p] ? 'success' : (p == 'NO_PORTE' ? 'error' : 'default')} size='small' title={'Noms de colonne ' + expectedTabAcierColumnNames[p].join(', ')
                } label={p} />;
            })}
        </Typography> : null}
    </Box>;
};
const ProjectDataTabListLogInspector = (props: { projectId: ModelId; }) => {
    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));
    if (!projectData) {
        return <Typography>Aucune donnée de projet disponible.</Typography>;
    }
    // row states
    return <Box>
        {!!projectData?.tabListeLog ? <Typography>
            {(Object.keys(projectData.tabListeLog.columns) as (keyof TabListLogColumns<any>)[]).map((p: keyof TabListLogColumns<any>) => {
                return <Chip component='span' key={p} color={projectData?.tabListeLog?.columns[p] ? 'success' : (p == 'NO_LOG' ? 'error' : 'default')} size='small' title={'Noms de colonne ' + expectedTabListeLogColumnNames[p].join(', ')
                } label={p} />;
            })}
        </Typography> : null}
    </Box>;
};
const ProjectDataTabPorteIntInspector = (props: { projectId: ModelId; }) => {
    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, props.projectId));


    if (!projectData) {
        return <Typography>Aucune donnée de projet disponible.</Typography>;
    }

    console.log('projectData.tabPorteInt', projectData.tabPorteInt);
    // row states
    return <Box>
        {!!projectData?.tabPorteInt ? <Typography>
            {(Object.keys(projectData?.tabPorteInt?.columns ?? []) as (keyof TabPorteIntData<any>)[]).map((p: keyof TabPorteIntData<any>) => {
                return <Chip component='span' key={p} color={projectData?.tabPorteInt?.columns[p] ? 'success' : (['TYPE_LOG', 'CHRONO'].includes(p) ? 'error' : 'default')} size='small' title={'Noms de colonne ' + expectedTabPourteIntColumnNames[p].join(', ')
                } label={p} />;
            })}
        </Typography> : null}
    </Box>;
};
